var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurfacewater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9896 0H11.0104C4.9295 0 0 4.9295 0 11.0104V47.9896C0 54.0705 4.9295 59 11.0104 59H47.9896C54.0705 59 59 54.0705 59 47.9896V11.0104C59 4.9295 54.0705 0 47.9896 0Z",
    fill: "#FFD562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9285 28.5985C36.9285 32.7013 33.6032 36.0267 29.5004 36.0267C25.3976 36.0267 22.0723 32.7013 22.0723 28.5985C22.0723 27.2092 22.4535 25.9052 23.1255 24.7917L29.5004 13.4062L35.8753 24.7917C36.5473 25.9052 36.9285 27.2092 36.9285 28.5985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8711 46.8902H17.1275C15.5361 46.8902 14.2461 45.6002 14.2461 44.0088C14.2461 42.4174 15.5361 41.1274 17.1275 41.1274H41.8711C43.4624 41.1274 44.7524 42.4174 44.7524 44.0088C44.7524 45.6002 43.4624 46.8902 41.8711 46.8902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfacewater);
export default __webpack_public_path__ + "static/media/surfacewater.769c5deb00c04b502876fc79e9a786f9.svg";
export { ForwardRef as ReactComponent };